import React, { memo, useState, useEffect } from 'react';
import { View, Text, Switch } from 'react-native';
import { THEME } from '../../constants/styles';

import { FormHelpers, Select } from '../components';
import { EMPLOYER_TYPE_MED_RECRUITER, EMPLOYER_TYPE_AIRFORCE } from '../../constants/employerTypes';

const termsRef = React.createRef();

const DEFAULT_FEATURES = {
  staffCasesAndPatients: true,
  orgCalendar: true,
  sendInvitesToPatients: true,
  referrals: true,
  geniusPha: false,
};
const DEFAULT_FEATURES_MED_RECRUITER = {
  staffCasesAndPatients: true,
  orgCalendar: true,
  sendInvitesToPatients: true,
  staffScheduling: true,
};

const TERMS_VALUES = {
  patient: { residentSingular: 'patient', residentPlural: 'patients' },
  resident: { residentSingular: 'resident', residentPlural: 'residents' },
  serviceMember: { residentSingular: 'serviceMember', residentPlural: 'serviceMembers' },
  provider: { residentSingular: 'provider', residentPlural: 'providers' },
};

const TERMS_OPTIONS = [
  { label: 'Patient/Patients', id: 'patient' },
  { label: 'Resident/Residents', id: 'resident' },
  { label: 'Service Member/Service Members', id: 'serviceMember' },
];
const TERMS_OPTIONS_MED_RECRUITER = [{ label: 'Provider/Providers', id: 'provider' }];

const ConfigForm = memo((props) => {
  const employer = props.employer || {};
  const uiConfigInitial = props.employer?.uiConfig || {};
  const isMedRecruiter = uiConfigInitial.type === EMPLOYER_TYPE_MED_RECRUITER;
  const [terms, setTerms] = useState(
    uiConfigInitial.terms?.residentSingular || (isMedRecruiter ? 'provider' : 'patient')
  );

  const [sendInvitesToPatientsEnabled, setSendInvitesToPatientsEnabled] = useState(
    uiConfigInitial.features?.sendInvitesToPatients != null
      ? uiConfigInitial.features.sendInvitesToPatients
      : isMedRecruiter
        ? DEFAULT_FEATURES_MED_RECRUITER.sendInvitesToPatients
        : DEFAULT_FEATURES.sendInvitesToPatients
  );
  const [referralsEnabled, setReferralsEnabled] = useState(
    uiConfigInitial.features?.referrals != null
      ? uiConfigInitial.features.referrals
      : DEFAULT_FEATURES.referrals
  );
  const [geniusPhaEnabled, setGeniusPhaEnabled] = useState(
    uiConfigInitial.features?.geniusPha != null
      ? uiConfigInitial.features.geniusPha
      : DEFAULT_FEATURES.geniusPha
  );

  useEffect(() => {
    const isValid = FormHelpers.validateFields([termsRef.current]);
    const uiConfig = {
      type: uiConfigInitial.type || EMPLOYER_TYPE_AIRFORCE,
      ...uiConfigInitial,
      terms: TERMS_VALUES[terms],
      features: isMedRecruiter
        ? {
            ...DEFAULT_FEATURES_MED_RECRUITER,
            sendInvitesToPatients: sendInvitesToPatientsEnabled,
          }
        : {
            ...DEFAULT_FEATURES,
            sendInvitesToPatients: sendInvitesToPatientsEnabled,
            referrals: referralsEnabled,
            geniusPha: geniusPhaEnabled,
          },
    };
    props.onDataChange({ ...employer, uiConfig }, isValid);
  }, [terms, sendInvitesToPatientsEnabled, referralsEnabled, geniusPhaEnabled]);
  return (
    <View style={{ marginBottom: 20 }}>
      <Select
        ref={termsRef}
        required={true}
        options={isMedRecruiter ? TERMS_OPTIONS_MED_RECRUITER : TERMS_OPTIONS}
        label={'Terms'}
        value={terms}
        onSelect={setTerms}
        webMode={true}
      />
      <View style={[THEME.basicRow, { marginTop: 20 }]}>
        <Switch
          value={sendInvitesToPatientsEnabled}
          onValueChange={setSendInvitesToPatientsEnabled}
        />
        <View style={{ width: 10 }} />
        <Text style={THEME.textMedium}>
          {' '}
          Send Invites to {isMedRecruiter ? 'Providers' : 'Residents'} Enabled
        </Text>
      </View>
      {!isMedRecruiter && (
        <>
          <View style={[THEME.basicRow, { marginTop: 25 }]}>
            <Switch value={referralsEnabled} onValueChange={setReferralsEnabled} />
            <View style={{ width: 10 }} />
            <Text style={THEME.textMedium}>Consults and Referrals Enabled</Text>
          </View>
          <View style={[THEME.basicRow, { marginTop: 25 }]}>
            <Switch value={geniusPhaEnabled} onValueChange={setGeniusPhaEnabled} />
            <View style={{ width: 10 }} />
            <Text style={THEME.textMedium}>Genius PHA Enabled</Text>
          </View>
        </>
      )}
    </View>
  );
});

export default ConfigForm;
